import Vue from 'vue';
import Router from 'vue-router';
import Store from './store';
import { can } from './utils/rights';

/** Add/replace client's router here */
import komacutPaths from './_komacut/router';

Vue.use(Router);

const paths = [
  {
    path: '/',
    view: 'Dashboard',
    client: 'komacut'
  },
  {
    path: '/login',
    view: 'Login',
  },
  {
    path: '/logout',
    view: 'Logout',
  },
  {
    path: '/users/:id?',
    name: 'users',
    view: 'Users',
    disabled: async () => !(await can('user', 'read')),
  },
  {
    path: '/roles/:id?',
    name: 'roles',
    view: 'Roles',
    disabled: async () => !(await can('role', 'read')),
  },
  {
    path: '/user_preferences',
    name: 'userPreferences',
    view: 'UserPreferences',
    disabled: async () => !(await can('user', 'read')),
  },

  /** Add/replace client's router here */
  ...komacutPaths
];

function route(path, view, name, props, client) {
  return {
    name,
    path,
    props,
    component: resolve => import(`@/${client ? `_${client}/` : ''}views/${view}.vue`).then(resolve)
  };
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: paths
    .map(path => route(path.path, path.view, path.name, path.props, path.client))
    .concat([{ path: '*', redirect: '/' }]),
});

const processDisabled = async f => {
  let result = false;
  if (_.isBoolean(f)) {
    result = f ? 'disabled' : false;
  } else if (_.isFunction(f)) {
    const ok = f();
    if (ok instanceof Promise) {
      result = (await ok) ? 'disabled' : false;
    } else {
      result = ok ? 'disabled' : false;
    }
  }
  return result;
};

// Global session route dispatching
router.beforeEach((to, from, next) => {
  // Authenticate with the local email/password strategy
  Store.dispatch('auth/authenticate').then(() => {
    processDisabled(_.get(_.find(paths, { name: to.name }), 'disabled', false)).then(r => {
      const ok = r !== 'disabled' && !['/signup', '/login'].includes(to.path);
      next(ok ? undefined : '/');
    });
  }).catch(() => {
    if (['/signup', '/login'].includes(to.path)) {
      next();
    } else {
      next('/login');
    }
  });
});

export default router;
